import { useState } from 'react';

export const useResize = () => {
  const MIN_WIDTH = 100;
  const MAX_WIDTH = 600;
  const DEFAULT_WIDTH = 300;
  
  const [leftWidth, setLeftWidth] = useState(DEFAULT_WIDTH);
  
  const onMouseDown = () => {
    document.body.style.cursor = 'col-resize';

    const onMouseMove = (e) => {
      let newWidth = e.clientX;
      if (newWidth < MIN_WIDTH) newWidth = MIN_WIDTH;
      if (newWidth > MAX_WIDTH) newWidth = MAX_WIDTH;
      setLeftWidth(newWidth);
    };

    const onMouseUp = () => {
      document.body.style.cursor = '';
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  return {
    leftWidth,
    onMouseDown,
    MIN_WIDTH,
    MAX_WIDTH
  };
};
